jQuery(document).ready(function($) {
  let $wrapper = $('.podcast__transcript--wrapper'); // Select the transcript wrapper element
  let scrollHeight = $wrapper.length > 0 ? $wrapper.get(0).scrollHeight : 0; // Get the scroll height of the wrapper if it exists
  let offsetHeight = $wrapper.length > 0 ? $wrapper.get(0).offsetHeight : 0; // Get the offset height of the wrapper if it exists
  let $loadMore = $('.podcast__transcript--more'); // Select the 'Load More' button

  // console.log('scrollHeight: ' + scrollHeight);
  // console.log('OffsetHeight: ' + offsetHeight);

  /* Show 'Load More' button if content hidden. */
  if (offsetHeight + 1 < scrollHeight) {
    $loadMore.css('display', 'flex');
  }

  /* Show all content when 'Load More' clicked. */
  if ($loadMore.length > 0) {
    $loadMore.find('.button').on('click', function(ev) {
      ev.preventDefault();

      if (offsetHeight <= scrollHeight) {
        $wrapper.css('max-height', '100%');
        $wrapper.css('overflow', 'visible');
        $(this).remove();
      }
    });
  }
});
